import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box } from "@mui/material";
import React from "react";
import { ListStateIcon } from "../ListStateIcon/ListStateIcon";

interface ListStateIconExpandedProps {
  hasChildren?: boolean;
  collapsed?: boolean;
  noMargin?: boolean;
  tooltip?: string;
  onClick?: () => void;
}

export const ListStateIconExpanded = (props: ListStateIconExpandedProps) =>
    props.hasChildren
        ? (
            <ListStateIcon
                icon={props.collapsed ? ChevronRightIcon : ExpandMoreIcon}
                tooltip={props.tooltip}
                noMargin={props.noMargin}
                onClick={props.onClick}
            />
        )
        : (
            <Box sx={{ minWidth: "20px" }} />
        );
